// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__2IEdx","footer":"ModalCreateQualiphyProcedure_footer__1iA81","additionData":"ModalCreateQualiphyProcedure_additionData__3XbM5"};